


import {SessionDuration} from './SessionDuration'; 
export class OrganisationIssueCreditVM {
    
    issuedTo?: string;
    
    duration?: SessionDuration;
    
}
